import moment from 'moment'

export default {
  getServiceName (serviceType) {
    switch (serviceType) {
      case 'shared': return 'Shared Ride'
      case 'opoli': return 'Direct Non-stop'
      case 'black': return 'Sedan'
      case 'SUV': return 'SUV'
      case 'suv': return 'SUV'
      case 'shuttle': return 'Private Van'
      case 'private shuttle': return 'Private Van'
    }
  },
  getServiceData (VueApp, id) {
    let services = VueApp.$store.state.services.list
    if (!services.length) { return 'Service Not Yet Loaded' }

    let index = services.findIndex(x => x.id === id)
    if (index > -1) {
      return services[index]
    }
    return 'Can\' find service'
  },
  getAllService (VueApp, callback) {
    VueApp.$sdk.get('/service?cache=' + moment().format('x'), {
      token: VueApp.$store.state.session.sessionToken,
      all: 1,
      order: 'priority'
    }, r => {
      VueApp.$store.commit('services/clearService')
      if (!r.error) {
        r.list.forEach(service => {
          if (service.brandId) {
            delete service.modified
            delete service.schema
            service.image = service.image || ''
            service.imageOff = service.imageOff || ''
            service.excerptWeb = service.excerptWeb || ''
            service.descriptionWeb = service.descriptionWeb || ''
            service.advantageWeb = service.advantageWeb || ''
            service.stops = service.stops || ''
            service.category = service.category || ''
            service.excerptApp = service.excerptApp || ''
            service.descriptionApp = service.descriptionApp || ''
            service.advantageApp = service.advantageApp || ''
            service.slogan = service.slogan || ''
            service.useShifts  = service.useShifts  || ''
            service.defaultTip  = service.defaultTip  || 0
            let unavailableTimes = []
            if (service.unavailableTimes) {
              service.unavailableTimes.forEach(x => {
                unavailableTimes.push(moment(x.start, 'X').format('MM/DD/YYYY'))
              })
            }
            let images = []
            if (service.images) {
              service.images.forEach(x => {
                images.push(x)
              })
            }
            service.unavailableTimes = unavailableTimes
            service.images = images
            service.unavailableTimP2p = service.unavailableTimeP2P || false
            service.unavailableTimFromAirport = service.unavailableTimeFromAirport || false
            service.unavailableTimToAirport = service.unavailableTimeToAirport || false
            service.unavailableTimeStart = service.unavailableTimeStart || 0
            service.unavailableTimeEnd = service.unavailableTimeEnd || 0
            VueApp.$store.commit('services/addService', service)
          }
        })
      }
      callback(r)
    }, '2.0')
  },
  updatePosition (VueApp, data, callback) {
    VueApp.$sdk.post('/service/' + data.id, {
      token: VueApp.$store.state.session.sessionToken,
      priority: data.priority
    }, r => {
      callback(r)
    }, '2.0')
  },
  toggleServiceEnable (VueApp, data, callback) {
    VueApp.$sdk.post('/service/' + data.id, {
      token: VueApp.$store.state.session.sessionToken,
      enabled: data.enabled
    }, r => {
      if (!r.error) {
        VueApp.$store.commit('services/setServiceEnable', data)
      }
      callback(r)
    }, '2.0')
  },
  addService (VueApp, callback) {
    let serviceStore = VueApp.$store.state.services
    let service = Object.assign({}, serviceStore.details)
    delete service.id
    delete service.brandId
    service.brandId = serviceStore.brandId
    service.token = VueApp.$store.state.session.sessionToken
    let newUnavailableTimes = []
    service.unavailableTimes.forEach(x => {
      let temp = moment(x, 'MM/DD/YYYY')
      newUnavailableTimes.push({
        start: moment(`${temp.format('MM/DD/YYYY')} 00:00:00`, 'MM/DD/YYYY hh:mm:ss').format('X'),
        end: moment(`${temp.format('MM/DD/YYYY')} 23:59:59`, 'MM/DD/YYYY hh:mm:ss').format('X')
      })
    })
    service.unavailableTimes = newUnavailableTimes
    if (service.optinPercent) {
      service.optinPercent = parseFloat(service.optinPercent)
    }
    let serviceUnavailable = serviceStore.serviceUnavailable
    service.unavailableTimeP2P = serviceUnavailable.p2p
    service.unavailableTimeFromAirport = serviceUnavailable.fromAirport
    service.unavailableTimeToAirport = serviceUnavailable.toAirport
    service.unavailableTimeStart = serviceUnavailable.startTime
    service.unavailableTimeEnd = serviceUnavailable.endTime
    VueApp.$sdk.post('/service', service, r => {
      if (!r.error) {
        VueApp.$store.commit('services/setDetailsData', {
          field: 'id',
          value: r.id
        })
        VueApp.$store.commit('services/setServiceId', r.id)
      }
      callback(r)
    }, '2.0')
  },
  updateService (VueApp, data, callback) {
    data.token = VueApp.$store.state.session.sessionToken
    let newData = Object.assign({}, data)
    let newUnavailableTimes = []
    data.unavailableTimes.forEach(x => {
      let temp = moment(x, 'MM/DD/YYYY')
      newUnavailableTimes.push({
        start: moment(`${temp.format('MM/DD/YYYY')} 00:00:00`, 'MM/DD/YYYY hh:mm:ss').format('X'),
        end: moment(`${temp.format('MM/DD/YYYY')} 23:59:59`, 'MM/DD/YYYY hh:mm:ss').format('X')
      })
    })
    newData.unavailableTimes = newUnavailableTimes
    if (newData.optinPercent) {
      newData.optinPercent = parseFloat(newData.optinPercent)
    }
    let serviceUnavailable = VueApp.$store.state.services.serviceUnavailable
    newData.unavailableTimeAsap = serviceUnavailable.asap
    newData.unavailableTimeFuture = serviceUnavailable.future
    newData.unavailableTimeP2P = serviceUnavailable.p2p
    newData.unavailableTimeFromAirport = serviceUnavailable.fromAirport
    newData.unavailableTimeToAirport = serviceUnavailable.toAirport
    newData.unavailableTimeStart = serviceUnavailable.startTime
    newData.unavailableTimeEnd = serviceUnavailable.endTime
    VueApp.$sdk.post('/service/' + data.id, newData, r => {
      callback(r)
    }, '2.0')
  },
  cloneService (VueApp, brandId, callback) {
    let service = Object.assign({}, VueApp.$store.state.services.details)
    delete service.id
    delete service.brandId
    service.brandId = brandId
    service.enabled = false
    service.token = VueApp.$store.state.session.sessionToken
    VueApp.$sdk.post('/service', service, r => {
      if (!r.error) {
        service.id = r.id
        delete service.token
        VueApp.$store.commit('services/addService', service)
      }
      callback(r)
    }, '2.0')
  },
  getEnabledDrivers (VueApp, service, callback) {
    VueApp.$sdk.get('/service/' + VueApp.$store.state.services.details.id + '/providers', {
      token: VueApp.$store.state.session.sessionToken
    }, r => {
      if (!r.error) {
        let drivers = []
        let initDrivers = []
        r.list.forEach(x => {
          drivers.push(x.ID)
          initDrivers.push(x.ID)
        })
        VueApp.$store.commit('services/setEnabledDrivers', drivers)
        let listed = VueApp.$store.state.services.users.list.map(x => x.id)
        if (listed.every(x => drivers.includes(x))) {
          VueApp.$store.commit('services/setCheck', true)
        } else {
          VueApp.$store.commit('services/setCheck', false)
        }
        VueApp.$store.commit('services/setInitialData', initDrivers)
      }
      callback(r)
    }, '2.0')
  },
  updateEnabledDrivers (VueApp, service, callback) {
    let drivers = []
    let initData = VueApp.$store.state.services.initialData
    let enabled = VueApp.$store.state.services.enabledDrivers
    initData.filter(function (x) {
      if (!enabled.includes(x)) {
        drivers.push({ 'id': x, 'enabled': false })
      }
    })
    enabled.forEach(x => drivers.push({ 'id': x, 'enabled': true }))
    VueApp.$sdk.post('/service/' + VueApp.$store.state.services.details.id + '/providers', {
      token: VueApp.$store.state.session.sessionToken,
      providers: drivers
    }, r => {
      if (!r.error) {
        let drivers = []
        r.list.forEach(x => drivers.push(x.ID))
        VueApp.$store.commit('services/setEnabledDrivers', drivers)
        // VueApp.$store.commit('services/setInitialData', drivers)
      }
      callback(r)
    }, '2.0')
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/services/index.js